/* JsonDiffControlRenderer.js */

"use strict";

const IconRegistry = require("@gluenetworks/icon_registry").getInstance();
const JsonComparatorUtil = require("@gluenetworks/json-comparator").JsonComparator;
const JsonDiffNavigationComponent = require("./JsonDiffNavigationComponent");
const StringDiffUtil = require("./util/StringDiffUtil");
const OrderJson = require("@gluenetworks/json-comparator").JsonSort;
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;
// const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;
const INDENT_SIZE = 2;
const START_ROW_KEY = "__startRow";
const _ = require("lodash");

class JsonDiffControlRenderer {
    constructor(model) {
        this._model = model;
        this._jsonComparatorUtil = new JsonComparatorUtil();

        this._rootElement = document.createElement("div");
        this._rootElement.classList.add("json-diff-control");
        this._rootElement.classList.add(this._model._theme || "dark");
        this._diff = {};
        this._markers = [];

        this._defineDebounceAndBinds();
        this._buildEditors();
        this._jsonDiffNavigationComponent = new JsonDiffNavigationComponent({
            leftEditor: this._leftEditor,
            rightEditor: this._rightEditor,
            theme: this._model._theme,
        });

        this._downloadButtonContainer = document.createElement("download-button-container");
        // this._downloadButtonContainer.classList.add("download-button-container");
        // this._downloadButton = new ButtonControl({
        //     label: "Download",
        //     darkTheme: false,
        //     class: "download-button-control"
        // });
        this._downloadButton = document.createElement("button");
        this._downloadButton.innerText = "Download";
        this._downloadButton.classList.add("download-button-control");
        this._downloadButtonContainer.appendChild(this._downloadButton);

        this._leftUserActionContainer = document.createElement("div");
        this._leftUserActionContainer.classList.add("left-user-actions", "user-actions");
        this._rightUserActionContainer = document.createElement("div");
        this._rightUserActionContainer.classList.add("right-user-actions", "user-actions");

        this._buildActionBar();
        this._buildUserActions();
        this._registerListeners();
        this.render();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _defineDebounceAndBinds() {
        this._onEditorSeparatorMouseDragHandler =
            this._onEditorSeparatorMouseDragHandler.bind(this);
        this._recalculateAndRenderDifferencesDebounce = _.debounce(
            this._recalculateAndRenderSideBySideViewDifferences.bind(this),
            100
        );
    }

    _registerListeners() {
        this._model.on(
            "FirstJson",
            (this._setFirstJsonOnEditor = this._setFirstJsonOnEditor.bind(this))
        );
        this._model.on(
            "SecondJson",
            (this._setSecondJsonOnEditor = this._setSecondJsonOnEditor.bind(this))
        );
        this._model.on(
            "scrollSynchronized",
            (this._setSynchronizedScroll = this._setSynchronizedScroll.bind(this))
        );
        this._model.on(
            "sideBySideView",
            (this._setSideBySideView = this._setSideBySideView.bind(this))
        );
        this._model.on("compactView", (this._setCompactView = this._setCompactView.bind(this)));

        this._model.on("UpdateHeight", (this._setHeight = this._setHeight.bind(this)));

        this._toggleViewButton.addEventListener(
            "click",
            (this._onToggleViewButtonClick = this._onToggleViewButtonClick.bind(this))
        );
        // this._editorSeparatorDiv.addEventListener('mousedown', this._onEditorSeparatorClick = this._onEditorSeparatorClick.bind(this));
        this._jsonDiffNavigationComponent.on(
            "scrollSynchronizedValueChanged",
            (this._onScrollSynchronizedValueChanged =
                this._onScrollSynchronizedValueChanged.bind(this))
        );
        this._downloadButton.addEventListener(
            "click",
            (this._onDownload = this._onDownload.bind(this))
        );
        // this._downloadButtonContainer.addEventListener("click", this._onUserActionClick = this._onUserActionClick.bind(this));
        this._rightUserActionContainer.addEventListener(
            "click",
            (this._onUserActionClick = this._onUserActionClick.bind(this))
        );
        this._leftUserActionContainer.addEventListener(
            "click",
            (this._onUserActionClick = this._onUserActionClick.bind(this))
        );
    }

    _unregisterListeners() {
        this._model.removeListener("FirstJson", this._setFirstJsonOnEditor);
        this._model.removeListener("SecondJson", this._setSecondJsonOnEditor);
        this._model.removeListener("scrollSynchronized", this._setSynchronizedScroll);
        this._model.removeListener("sideBySideView", this._setSideBySideView);
        this._model.removeListener("compactView", this._setCompactView);
        this._model.removeListener("UpdateHeight", this._setHeight);
        this._downloadButton.removeEventListener("click", this._onDownload);
        // this._downloadButtonContainer.removeEventListener("click", this._onUserActionClick);
        this._rightUserActionContainer.removeEventListener("click", this._onUserActionClick);
        this._leftUserActionContainer.removeEventListener("click", this._onUserActionClick);

        this._toggleViewButton.removeEventListener("click", this._onToggleViewButtonClick);
        // this._editorSeparatorDiv.removeEventListener('mousedown', this._onEditorSeparatorClick);
        document.body.removeEventListener("pointermove", this._onEditorSeparatorMouseDragHandler);
        this._jsonDiffNavigationComponent.removeListener(
            "scrollSynchronizedValueChanged",
            this._onScrollSynchronizedValueChanged
        );
    }

    _buildEditors() {
        this._editorsDiv = document.createElement("div");
        this._editorsDiv.classList.add("editors");

        let leftEditorDiv = document.createElement("div");
        leftEditorDiv.classList.add("left");
        let rightEditorDiv = document.createElement("div");
        rightEditorDiv.classList.add("right");
        this._leftEditor = ace.edit(leftEditorDiv);
        this._rightEditor = ace.edit(rightEditorDiv);

        this._editorSeparatorDiv = document.createElement("div");
        this._editorSeparatorDiv.classList.add("editor-separator");

        this._editorsDiv.appendChild(leftEditorDiv);
        this._editorsDiv.appendChild(this._editorSeparatorDiv);
        this._editorsDiv.appendChild(rightEditorDiv);
    }

    _buildUserActions() {
        if (this._model._actionsList.length < 1) {
            return;
        }

        this._model._actionsList.forEach((action) => {
            const actBtn = new ButtonControl({
                label: action.display || "Button",
                darkTheme: true,
                class: "actBtn",
            });
            actBtn.setAttribute("actname", action.name);
            if (action.position && action.position === "left") {
                this._leftUserActionContainer.appendChild(actBtn._renderer._rootElem);
            } else {
                this._rightUserActionContainer.appendChild(actBtn._renderer._rootElem);
            }
        });
    }

    _buildActionBar() {
        this._actionDiv = document.createElement("div");
        this._actionDiv.classList.add("actions");

        this._toggleViewButton = document.createElement("toggle-icon-gl");
        this._toggleViewButton.classList.add("single-pane-view");
        this._toggleViewButton.dataset.icon = "configdrift.compare_line_by_line";
        this._toggleViewButton.setAttribute("title", "Switch to Single Pane View");

        this._actionDiv.appendChild(this._toggleViewButton);
    }

    _configureEditors() {
        this._leftEditor.renderer.setScrollMargin(0, 10, 0, 10);
        this._rightEditor.renderer.setScrollMargin(0, 10, 0, 10);

        let basePath = "/resources/ace-builds/src-min-noconflict";
        if (window.location.pathname !== "/" && window.location.pathname !== "/index.html") {
            basePath = window.location.pathname + basePath;
        }
        ace.config.set("basePath", basePath);

        this._leftEditor.setReadOnly(true);
        this._rightEditor.setReadOnly(true);
        this._leftEditor.setShowPrintMargin(false);
        this._rightEditor.setShowPrintMargin(false);
        this._leftEditor.renderer.setDisplayIndentGuides(false);
        this._rightEditor.renderer.setDisplayIndentGuides(false);
        this._setJsonsToCompareOnEditors();
        this._setModeOnEditors(this._markers, true);
        this._previousRightScrollTop = this._rightEditor.session.getScrollTop();
        this._previousLeftScrollTop = this._leftEditor.session.getScrollTop();
    }

    _setModeOnEditors(markers, sideBySideView = true) {
        let JsonMode = ace.require("ace/mode/json").Mode;
        const DiffFoldMode = require("./mode/DiffFoldingRules").DiffFoldMode;

        let leftEditorMode = new JsonMode();
        this._leftFoldingRules = new DiffFoldMode(markers, sideBySideView, true);
        leftEditorMode.foldingRules = this._leftFoldingRules;
        this._leftEditor.session.setMode(leftEditorMode);

        if (sideBySideView) {
            let rightEditorMode = new JsonMode();
            this._rightFoldingRules = new DiffFoldMode(markers, sideBySideView, false);
            rightEditorMode.foldingRules = this._rightFoldingRules;
            this._rightEditor.session.setMode(rightEditorMode);
        }
    }

    _setJsonsToCompareOnEditors() {
        this._setFirstJsonOnEditor();
        this._setSecondJsonOnEditor();
    }

    _setMarkers(markers) {
        this._markers = markers;
        this.model.setMarkers(markers);
        this._setModeOnEditors(markers, this._model.sideBySideView);
        if (this._jsonDiffNavigationComponent) {
            this._jsonDiffNavigationComponent.setMarkers(markers);
        }
    }

    _recalculateAndRenderSideBySideViewDifferences() {
        this._highlightSideBySideViewDifferences();
        this._setMarkers(this._markers);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    shutdown() {
        this._unregisterListeners();
        this._jsonComparatorUtil = undefined;
        this._markers = undefined;
        this._currentHighlightedDifferenceIndex = undefined;
        this._leftEditor.destroy();
        this._rightEditor.destroy();

        this._leftEditor = undefined;
        this._rightEditor = undefined;
        this._leftFoldingRules = undefined;
        this._rightFoldingRules = undefined;

        this._recalculateAndRenderDifferencesDebounce = undefined;
        this._startingLeftEditorWidth = undefined;
        this._startingRightEditorWidth = undefined;
        this._xOffset = undefined;

        this._rootElement.remove();
        this._rootElement = undefined;
        this._editorSeparatorDiv = undefined;
        this._editorsDiv = undefined;
        this._actionDiv = undefined;
        return this._jsonDiffNavigationComponent.shutdown().then(() => {
            this._jsonDiffNavigationComponent = undefined;
        });
    }

    render() {
        this._actionDiv.appendChild(this._jsonDiffNavigationComponent.renderer.rootElement);
        this._rootElement.appendChild(this._editorsDiv);
        this._rootElement.appendChild(this._actionDiv);
        this._actionDiv.appendChild(this._leftUserActionContainer);
        this._actionDiv.appendChild(this._rightUserActionContainer);
        this._actionDiv.appendChild(this._downloadButtonContainer);

        //configure editor & session
        this._configureEditors();
        this._setSynchronizedScroll();
        setTimeout(() => {
            this._setSideBySideView();
            this._setCompactView();
        }, 100);
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElement;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END PUBLIC COMPONENT RENDERER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /**
     * Fired when first json is updated on model
     * @private
     */
    _onFirstJson() {
        this._setFirstJsonOnEditor();
    }

    /**
     * Fired when second json is updated on model
     * @private
     */
    _onSecondJson() {
        this._setSecondJsonOnEditor();
    }

    _setHeight(leftHeight, rightHeight) {
        if (!leftHeight && !rightHeight) {
            console.warn("Set height called with no arguments. Requires a number type argument");
        }

        if (!leftHeight) {
            leftHeight = rightHeight;
        }

        if (!rightHeight) {
            rightHeight = leftHeight;
        }

        this._leftEditor.container.style.height = leftHeight + "px";
        this._rightEditor.container.style.height = rightHeight + "px";
        this._leftEditor.resize();
        this._rightEditor.resize();
    }

    _onUserActionClick(evt) {
        const actName = evt.target.getAttribute("actname");
        console.log(actName);
        if (
            !actName ||
            !(this._model._userActions[actName] && this._model._userActions[actName].cb)
        ) {
            return;
        }
        this._model._userActions[actName].cb();
    }

    _onDownload() {
        // ToDo: Make this generic
        if (!this._model._downloadCB) {
            console.warn("No download method provided");
            return;
        }
        let diff = "";
        if (this._diff && typeof this._diff === "object") {
            diff = JSON.stringify(this._diff, null, INDENT_SIZE);
        }
        this._downloadButton.setAttribute("disabled", true);
        this._model._downloadCB(diff, "json", "application/json").finally(() => {
            this._downloadButton.removeAttribute("disabled");
        });
    }

    _setSynchronizedScroll() {
        if (this._jsonDiffNavigationComponent) {
            let scrollSynchronized = this._model.sideBySideView
                ? this._model.isScrollSynchronized()
                : false;
            this._jsonDiffNavigationComponent.setScrollSynchronized(scrollSynchronized);
        }
    }

    _setSideBySideView() {
        if (this._model.isSideBySideView()) {
            this._switchToSideBySideView();
        } else {
            this._switchToSinglePaneView();
        }
    }

    _setCompactView() {
        if (this._jsonDiffNavigationComponent) {
            this._jsonDiffNavigationComponent.setCompactView(this._model.compactView);
        }
    }

    _onToggleViewButtonClick() {
        this._model.setSideBySideView(!this._model.isSideBySideView());
    }

    _onEditorSeparatorClick(event) {
        event.preventDefault();
        this._startingLeftEditorWidth = this._leftEditor.container.offsetWidth;
        this._startingRightEditorWidth = this._rightEditor.container.offsetWidth;
        this._xOffset = event.pageX;
        document.body.addEventListener("pointermove", this._onEditorSeparatorMouseDragHandler);
    }

    _onScrollSynchronizedValueChanged(newScrollSynchronizedValue) {
        this._model.setScrollSynchronized(newScrollSynchronizedValue);
    }

    _onEditorSeparatorMouseDragHandler(mouseEvent) {
        mouseEvent.preventDefault();
        const primaryButtonPressed = mouseEvent.buttons === 1;
        if (!primaryButtonPressed) {
            document.body.removeEventListener(
                "pointermove",
                this._onEditorSeparatorMouseDragHandler
            );
            return;
        }

        let changeInLeftEditorWidth = mouseEvent.pageX - this._xOffset;
        let minWidth = 250;
        let maxWidth = 750;
        let newLeftEditorWidth = changeInLeftEditorWidth + this._startingLeftEditorWidth;
        let newRightEditorWidth = this._startingRightEditorWidth - changeInLeftEditorWidth;
        if (newLeftEditorWidth > maxWidth) {
            newLeftEditorWidth = maxWidth;
            newRightEditorWidth = minWidth;
        } else if (newLeftEditorWidth < minWidth) {
            newLeftEditorWidth = minWidth;
            newRightEditorWidth = maxWidth;
        }
        this._leftEditor.container.style.width = newLeftEditorWidth + "px";
        this._rightEditor.container.style.width = newRightEditorWidth + "px";
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    _setFirstJsonOnEditor() {
        this._jsonComparatorUtil.setFirstJson(this._model.firstJson);
        this._firstJsonWithoutCyclicRefs =
            this._jsonComparatorUtil.getFirstJsonWithoutCircularRefs();
        let jsonString = JSON.stringify(this._firstJsonWithoutCyclicRefs, null, INDENT_SIZE);
        this._leftEditor.session.setValue(jsonString);
        this._recalculateAndRenderDifferencesDebounce();
    }

    _setSecondJsonOnEditor() {
        this._jsonComparatorUtil.setSecondJson(this._model.secondJson);
        this._secondJsonWithoutCyclicRefs =
            this._jsonComparatorUtil.getSecondJsonWithoutCircularRefs();
        this._secondJsonWithoutCyclicRefs = OrderJson.order(
            this._secondJsonWithoutCyclicRefs,
            this._firstJsonWithoutCyclicRefs
        );
        let jsonString = JSON.stringify(this._secondJsonWithoutCyclicRefs, null, INDENT_SIZE);
        this._rightEditor.session.setValue(jsonString);
        this._recalculateAndRenderDifferencesDebounce();
    }

    _highlightSideBySideViewDifferences() {
        this._removeHighlightMarkers();
        let differences = (this._diff = this._jsonComparatorUtil.compare(false));
        // console.log('diff calculated: ' + JSON.stringify(differences, null, 2));
        let leftEditorLineNumberByPathCache = {"#": {}};
        let rightEditorLineNumberByPathCache = {"#": {}};
        leftEditorLineNumberByPathCache["#"][START_ROW_KEY] = 0;
        rightEditorLineNumberByPathCache["#"][START_ROW_KEY] = 0;
        let changeTraversalStack = [differences];
        let changePathTraversalStack = [["#"]];
        while (changeTraversalStack.length > 0) {
            let currentDifference = changeTraversalStack.pop();
            let currentDifferencePath = changePathTraversalStack.pop();
            if (_.has(currentDifference, "oldVal") || _.has(currentDifference, "newVal")) {
                this._highlightDifference(
                    currentDifference,
                    currentDifferencePath,
                    leftEditorLineNumberByPathCache,
                    rightEditorLineNumberByPathCache
                );
            } else {
                this._getLineNumberOfPath(
                    currentDifferencePath,
                    this._firstJsonWithoutCyclicRefs,
                    leftEditorLineNumberByPathCache,
                    this._leftEditor
                );
                this._getLineNumberOfPath(
                    currentDifferencePath,
                    this._secondJsonWithoutCyclicRefs,
                    rightEditorLineNumberByPathCache,
                    this._rightEditor
                );
                Object.keys(currentDifference).forEach(function (childKey) {
                    changeTraversalStack.push(currentDifference[childKey]);
                    let childPath = _.concat(currentDifferencePath, childKey);
                    changePathTraversalStack.push(childPath);
                });
            }
        }
        this._currentHighlightedDifferenceIndex = -1;
    }

    _highlightDifference(
        difference,
        path,
        leftEditorLineNumberByPathCache,
        rightEditorLineNumberByPathCache
    ) {
        let differenceType = difference.__type;
        let leftPathStartLineNumber = this._getLineNumberOfPath(
            path,
            this._firstJsonWithoutCyclicRefs,
            leftEditorLineNumberByPathCache,
            this._leftEditor
        );
        let rightPathStartLineNumber = this._getLineNumberOfPath(
            path,
            this._secondJsonWithoutCyclicRefs,
            rightEditorLineNumberByPathCache,
            this._rightEditor
        );
        let leftHighlightRange, rightHighlightRange;
        if (differenceType === "updated") {
            leftHighlightRange = this._getHighlightRangeOfDifference(
                difference.oldVal,
                differenceType,
                path,
                leftPathStartLineNumber,
                this._leftEditor
            );
            rightHighlightRange = this._getHighlightRangeOfDifference(
                difference.newVal,
                differenceType,
                path,
                rightPathStartLineNumber,
                this._rightEditor
            );
        } else if (differenceType === "added") {
            rightHighlightRange = this._getHighlightRangeOfDifference(
                difference.newVal,
                differenceType,
                path,
                rightPathStartLineNumber,
                this._rightEditor
            );
            let lineNumberOfAddedPath = this._getLineNumberOfAddedPath(
                path,
                leftEditorLineNumberByPathCache,
                rightEditorLineNumberByPathCache
            );
            leftHighlightRange = new (ace.require("ace/range").Range)(
                lineNumberOfAddedPath,
                0,
                lineNumberOfAddedPath,
                this._leftEditor.session.getLine(lineNumberOfAddedPath).length + 1
            );
            leftHighlightRange.end.column =
                leftHighlightRange.end.column === this._leftEditor.session.getLength() - 1
                    ? leftHighlightRange.end.column + 1
                    : leftHighlightRange.end.column;
        } else if (differenceType === "removed") {
            leftHighlightRange = this._getHighlightRangeOfDifference(
                difference.oldVal,
                differenceType,
                path,
                leftPathStartLineNumber,
                this._leftEditor
            );
            let lineNumberOfDeletedPath = this._getLineNumberOfDeletedPath(
                path,
                leftEditorLineNumberByPathCache,
                rightEditorLineNumberByPathCache
            );
            rightHighlightRange = new (ace.require("ace/range").Range)(
                lineNumberOfDeletedPath,
                0,
                lineNumberOfDeletedPath,
                this._rightEditor.session.getLine(lineNumberOfDeletedPath).length
            );
        }
        let markerIds = this._addMarkerForGivenDifference(
            difference,
            path,
            leftHighlightRange,
            rightHighlightRange
        );
        this._storeNewMarkersIntoSortedMarkersArray(markerIds, differenceType);
    }

    _addMarkerForGivenDifference(difference, path, leftHighlightRange, rightHighlightRange) {
        let leftMarkerId, rightMarkerId;
        let differenceType = difference.__type;
        // console.log(`leftHighlightRange of ${differenceType} path ${path}: ` + leftHighlightRange.toString());
        // console.log(`rightHighlightRange of ${differenceType} path ${path}: `+ rightHighlightRange.toString());
        if (differenceType === "updated") {
            let leftHighlightUpdatedLineRange = new (ace.require("ace/range").Range)(
                leftHighlightRange.start.row,
                0,
                leftHighlightRange.end.row,
                this._leftEditor.session.getLine(leftHighlightRange.end.row).length + 1
            );
            leftMarkerId = this._leftEditor.session.addMarker(
                leftHighlightUpdatedLineRange,
                "updated-background",
                "fullLine",
                false
            );
            let rightHighlightUpdatedLineRange = new (ace.require("ace/range").Range)(
                rightHighlightRange.start.row,
                0,
                rightHighlightRange.end.row,
                this._rightEditor.session.getLine(rightHighlightRange.end.row).length + 1
            );
            rightMarkerId = this._rightEditor.session.addMarker(
                rightHighlightUpdatedLineRange,
                "updated-background",
                "fullLine",
                false
            );
            this._highlightUpdateDifferences(difference, leftHighlightRange, rightHighlightRange);
        } else if (differenceType === "added") {
            leftMarkerId = this._leftEditor.session.addMarker(
                leftHighlightRange,
                "added-line",
                "fullLine",
                false
            );
            rightMarkerId = this._rightEditor.session.addMarker(
                rightHighlightRange,
                "added",
                "fullLine",
                false
            );
        } else {
            leftMarkerId = this._leftEditor.session.addMarker(
                leftHighlightRange,
                "removed",
                "fullLine",
                false
            );
            rightMarkerId = this._rightEditor.session.addMarker(
                rightHighlightRange,
                "removed-line",
                "fullLine",
                false
            );
        }
        return {left: leftMarkerId, right: rightMarkerId};
    }

    _highlightUpdateDifferences(
        diff,
        leftHighlightRange,
        rightHighlightRange,
        sideBySideView = true
    ) {
        let simpleType =
            (_.isString(diff.oldVal) && _.isString(diff.newVal)) ||
            (_.isNumber(diff.oldVal) && _.isNumber(diff.newVal));
        let rightMarkerEditor = sideBySideView ? this._rightEditor : this._leftEditor;
        if (!simpleType) {
            //let leftHighlightUpdatedLineRange = new (ace.require('ace/range').Range)(leftHighlightRange.start.row, 0, leftHighlightRange.end.row, this._leftEditor.session.getLine(leftHighlightRange.end.row).length+1);
            this._leftEditor.session.addMarker(
                leftHighlightRange,
                "updated-removed",
                "string",
                false
            );

            //let rightHighlightUpdatedLineRange = new (ace.require('ace/range').Range)(rightHighlightRange.start.row, 0, rightHighlightRange.end.row, rightMarkerEditor.session.getLine(rightHighlightRange.end.row).length+1);
            rightMarkerEditor.session.addMarker(
                rightHighlightRange,
                "updated-added",
                "string",
                false
            );
        } else {
            let textDiffs = StringDiffUtil.getDiff(diff.oldVal + "", diff.newVal + "");
            let leftIndex = leftHighlightRange.start.column;
            let rightIndex = rightHighlightRange.start.column;
            if (_.isString(diff.oldVal)) {
                leftIndex++;
                rightIndex++;
            }
            textDiffs.forEach((currentDiff) => {
                if (currentDiff[0] === 0) {
                    // unchanged text
                    //no highlight
                    leftIndex += currentDiff[1].length;
                    rightIndex += currentDiff[1].length;
                } else if (currentDiff[0] === 1) {
                    //added text - highlight with green
                    let range = new (ace.require("ace/range").Range)(
                        rightHighlightRange.start.row,
                        rightIndex,
                        rightHighlightRange.end.row,
                        rightIndex + currentDiff[1].length
                    );
                    rightMarkerEditor.session.addMarker(range, "updated-added", "string", false);
                    rightIndex += currentDiff[1].length;
                } else {
                    //removed text - highlight with green
                    let range = new (ace.require("ace/range").Range)(
                        leftHighlightRange.start.row,
                        leftIndex,
                        leftHighlightRange.end.row,
                        leftIndex + currentDiff[1].length
                    );
                    leftIndex += currentDiff[1].length;
                    this._leftEditor.session.addMarker(range, "updated-removed", "string", false);
                }
            });
        }
    }

    //_addGutterDecorationsForGivenRange(range, differenceType) {
    // let decorationClass = differenceType + '-gutter';
    // if(differenceType === 'removed') {
    //     decorationClass = 'removed-line-gutter'
    // }
    // for(let i=range.start.row; i<=range.end.row; i++) {
    //     if(!(i === range.end.row && range.end.column === 0)) {
    //         this._rightEditor.session.addGutterDecoration(i, decorationClass);
    //     }
    // }
    //}

    _storeNewMarkersIntoSortedMarkersArray(markerIdsToInsert, differenceType) {
        let leftMarker = this._leftEditor.session.getMarkers(false)[markerIdsToInsert.left];
        let rightMarker = this._rightEditor.session.getMarkers(false)[markerIdsToInsert.right];
        let insertionIndex;
        let markersToInsert = {left: leftMarker, right: rightMarker};
        if (differenceType === "added") {
            insertionIndex = _.sortedIndexBy(
                this._markers,
                markersToInsert,
                "left.range.start.row"
            );
            if (
                insertionIndex < this._markers.length &&
                this._markers[insertionIndex].left.range.isEqual(leftMarker.range)
            ) {
                let foundInsertionIndex = false;
                while (insertionIndex < this._markers.length && !foundInsertionIndex) {
                    if (
                        rightMarker.range.start.row <
                        this._markers[insertionIndex].right.range.start.row
                    ) {
                        foundInsertionIndex = true;
                    } else {
                        insertionIndex++;
                    }
                }
            }
        } else {
            insertionIndex = _.sortedLastIndexBy(
                this._markers,
                markersToInsert,
                "left.range.start.row"
            );
        }
        this._markers.splice(insertionIndex, 0, markersToInsert);
    }

    _getLineNumberOfPath(path, json, lineNumbersByPath, editor) {
        if (_.has(lineNumbersByPath, path)) {
            return this._getStartRowOfPath(lineNumbersByPath, path);
        }
        if (!_.has(json, this._getRealPathFromInternalPath(path))) {
            return undefined;
        }
        if (_.last(path).match(/^_idx_(\d)+$/)) {
            //get it in a different way
            let lineNumberOfCurrentPath = this._getLineNumberOfArrayIndexInPath(
                path,
                lineNumbersByPath,
                editor
            );
            this._setStartRowOfPath(lineNumbersByPath, path, lineNumberOfCurrentPath);
        } else {
            let parentPath = this._getParentPath(path);
            let currentPathKey = this._getLastKeyFromPath(path);
            let currentPathIndentation = this._getIndentationGivenPath(path);
            let searchNeedle = "^" + _.escapeRegExp(`${currentPathIndentation}"${currentPathKey}"`);
            let searchOptions = {
                needle: searchNeedle,
                start: {row: this._getStartRowOfPath(lineNumbersByPath, parentPath), column: 0},
                regExp: true,
            };
            let searchObject = new (ace.require("ace/search").Search)();
            searchObject.set(searchOptions);
            let currentPathRange = searchObject.find(editor.session);
            this._setStartRowOfPath(
                lineNumbersByPath,
                path,
                currentPathRange ? currentPathRange.start.row : undefined
            );
            if (!currentPathRange) {
                console.log(
                    "%cUnable to find start row of path " + JSON.stringify(path),
                    "background-color: orange"
                );
            }
        }
        // console.log(`line # of path ${path}: ` + lineNumbersByPath[path]);
        return this._getStartRowOfPath(lineNumbersByPath, path);
    }

    _getRealPathFromInternalPath(path) {
        let realPath = [];
        path.slice(1).forEach((element) => {
            let elementTx = element.startsWith("_idx_")
                ? element.substring("_idx_".length)
                : element;
            realPath.push(elementTx);
        });
        return realPath;
    }

    _getLineNumberOfDeletedPath(path, leftLineNumbersByPath, rightLineNumbersByPath) {
        let lineNumberOfDeletedPath = undefined;
        let parentPath = this._getParentPath(path);
        let currentPathKey = this._getLastKeyFromPath(path);
        let parentPathWithCorrectIndices = this._getRealPathFromInternalPath(parentPath);
        let firstJsonKeysOfParent = !_.isEmpty(parentPathWithCorrectIndices)
            ? Object.keys(_.get(this._firstJsonWithoutCyclicRefs, parentPathWithCorrectIndices))
            : Object.keys(this._firstJsonWithoutCyclicRefs);
        let secondJsonParentObj = !_.isEmpty(parentPathWithCorrectIndices)
            ? _.get(this._secondJsonWithoutCyclicRefs, parentPathWithCorrectIndices)
            : this._secondJsonWithoutCyclicRefs;
        let secondJsonKeysOfParent = Object.keys(secondJsonParentObj);
        let indexOfRemovedKeyOnFirstJson = firstJsonKeysOfParent.indexOf(currentPathKey);
        let keyAfterDeletedElement = undefined;

        if (indexOfRemovedKeyOnFirstJson !== 0 && isNaN(currentPathKey)) {
            for (let i = indexOfRemovedKeyOnFirstJson - 1; i > 0 && !keyAfterDeletedElement; i--) {
                if (secondJsonKeysOfParent.includes(firstJsonKeysOfParent[i])) {
                    keyAfterDeletedElement = firstJsonKeysOfParent[i];
                }
            }
        }
        if (!keyAfterDeletedElement) {
            let startLineOfParent = this._getStartRowOfPath(rightLineNumbersByPath, parentPath);
            //if all its siblings are deleted... show the deleted line as first child of right json
            let showDeletedLineAsFirstChildOnSecondJson =
                indexOfRemovedKeyOnFirstJson === 0 ||
                !firstJsonKeysOfParent.some((currentKey) => {
                    return secondJsonKeysOfParent.indexOf(currentKey) >= 0;
                });
            if (showDeletedLineAsFirstChildOnSecondJson) {
                lineNumberOfDeletedPath = startLineOfParent + 1;
            } else {
                let textRangeOfParent = this._getTextRangeOfPath(
                    secondJsonParentObj,
                    parentPath,
                    startLineOfParent,
                    this._rightEditor
                );
                lineNumberOfDeletedPath = textRangeOfParent.end.row;
            }
        } else {
            let pathOfKeyAfterRemovedElement = _.concat(parentPath, keyAfterDeletedElement);
            let startLineOfKeyAfterRemovedElement = this._getLineNumberOfPath(
                pathOfKeyAfterRemovedElement,
                this._secondJsonWithoutCyclicRefs,
                rightLineNumbersByPath,
                this._rightEditor
            );
            let textRangeOfRemovedAfterElement = this._getTextRangeOfPath(
                secondJsonParentObj[keyAfterDeletedElement],
                pathOfKeyAfterRemovedElement,
                startLineOfKeyAfterRemovedElement,
                this._rightEditor
            );
            lineNumberOfDeletedPath = textRangeOfRemovedAfterElement.end.row + 1;
        }
        return lineNumberOfDeletedPath;
    }

    _getLineNumberOfAddedPath(path, leftLineNumbersByPath) {
        //, rightLineNumbersByPath) {
        let lineNumberOfAddedPath = undefined;
        let parentPath = this._getParentPath(path);
        let currentPathKey = this._getLastKeyFromPath(path);
        let parentPathWithCorrectIndices = this._getRealPathFromInternalPath(parentPath);
        let leftJsonParentObj = !_.isEmpty(parentPathWithCorrectIndices)
            ? _.get(this._firstJsonWithoutCyclicRefs, parentPathWithCorrectIndices)
            : this._firstJsonWithoutCyclicRefs;
        let firstJsonKeysOfParent = Object.keys(leftJsonParentObj);
        let secondJsonKeysOfParent = !_.isEmpty(parentPathWithCorrectIndices)
            ? Object.keys(_.get(this._secondJsonWithoutCyclicRefs, parentPathWithCorrectIndices))
            : Object.keys(this._secondJsonWithoutCyclicRefs);

        let indexOfAddedKeyOnSecondJson = secondJsonKeysOfParent.indexOf(currentPathKey);
        let keyAfterAddedElement = undefined;
        if (isNaN(currentPathKey)) {
            for (
                let i = indexOfAddedKeyOnSecondJson + 1;
                i < secondJsonKeysOfParent.length && !keyAfterAddedElement;
                i++
            ) {
                if (firstJsonKeysOfParent.includes(secondJsonKeysOfParent[i])) {
                    keyAfterAddedElement = secondJsonKeysOfParent[i];
                }
            }
        }
        if (!keyAfterAddedElement) {
            let startLineOfParent = this._getStartRowOfPath(leftLineNumbersByPath, parentPath);
            let textRangeOfParent = this._getTextRangeOfPath(
                leftJsonParentObj,
                parentPath,
                startLineOfParent,
                this._leftEditor
            );
            lineNumberOfAddedPath = textRangeOfParent.end.row;
        } else {
            let pathOfKeyAfterNewElement = _.concat(parentPath, keyAfterAddedElement);
            lineNumberOfAddedPath = this._getLineNumberOfPath(
                pathOfKeyAfterNewElement,
                this._firstJsonWithoutCyclicRefs,
                leftLineNumbersByPath,
                this._leftEditor
            );
        }
        return lineNumberOfAddedPath;
    }

    _getLineNumberOfArrayIndexInPath(path, lineNumbersByPath, editor) {
        let parentPath = this._getParentPath(path);
        let currentPathKey = parseInt(this._getLastKeyFromPath(path));
        let currentPathIndentation = this._getIndentationGivenPath(path);
        let searchNeedle = `^${currentPathIndentation}\\S`;
        let searchOptions = {
            needle: searchNeedle,
            start: {row: this._getStartRowOfPath(lineNumbersByPath, parentPath) + 1, column: 0},
            regExp: true,
        };
        let searchObject = new (ace.require("ace/search").Search)();
        searchObject.set(searchOptions);
        let currentPathRange = undefined;
        let count = -1;
        // console.log("starting line # of array " + parentPath + "[0] is : " + searchOptions.start.row);
        let objOrArrayStartRegex = `^${currentPathIndentation}[{[]`;
        while (count++ < currentPathKey && currentPathRange !== null) {
            currentPathRange = searchObject.find(editor.session);
            // console.log("currentPathRange: " + JSON.stringify(currentPathRange));
            if (currentPathRange) {
                searchOptions.start = {
                    row: currentPathRange.start.row + 1,
                    column: currentPathRange.start.column,
                };
                if (
                    count < currentPathKey &&
                    editor.session.getLine(currentPathRange.start.row).match(objOrArrayStartRegex)
                ) {
                    count--;
                }
                searchObject.set(searchOptions);
            }
            // console.log("line # of current index " + _.get(currentPathRange, 'start.row'));
        }
        return currentPathRange ? currentPathRange.start.row : undefined;
    }

    _getIndentationGivenPath(path) {
        return " ".repeat((path.length - 1) * INDENT_SIZE);
    }

    _getStartRowOfPath(lineNumbersByPath, path) {
        let startRowPath = _.concat(path, START_ROW_KEY);
        return _.get(lineNumbersByPath, startRowPath, undefined);
    }

    _setStartRowOfPath(lineNumbersByPath, path, startRow) {
        let startRowPath = _.concat(path, START_ROW_KEY);
        return _.set(lineNumbersByPath, startRowPath, startRow);
    }

    _getHighlightRangeOfDifference(changeVal, differenceType, path, pathStartLineNumber, editor) {
        let pathIndentation = this._getIndentationGivenPath(path);
        let key = this._getLastKeyFromPath(path);
        let highlightRange = this._getTextRangeOfPath(changeVal, path, pathStartLineNumber, editor);
        if (differenceType === "updated") {
            let highlightStartColumn = isNaN(key)
                ? `${pathIndentation}"${key}": `.length
                : `${pathIndentation}`.length;
            highlightRange.start.column = highlightStartColumn;
        } else if (differenceType === "removed") {
            highlightRange.end.column =
                this._leftEditor.session.getLine(highlightRange.end.row).length + 1;
        } else if (differenceType === "added") {
            highlightRange.end.column =
                this._rightEditor.session.getLine(highlightRange.end.row).length + 1;
        }
        return highlightRange;
    }

    _getTextRangeOfPath(changeVal, path, pathStartLineNumber, editor) {
        let pathIndentation = this._getIndentationGivenPath(path);
        let searchNeedle = `^${pathIndentation}\\S`;
        //let key = this._getLastKeyFromPath(path);
        let highlightStartColumn = 0;
        let textRangeOfPath;
        if ((_.isPlainObject(changeVal) || _.isArray(changeVal)) && !_.isEmpty(changeVal)) {
            let searchOptions = {
                needle: searchNeedle,
                start: {row: pathStartLineNumber + 1, column: 0},
                regExp: true,
                wrap: false,
            };
            let searchObject = new (ace.require("ace/search").Search)();
            searchObject.set(searchOptions);
            let differenceEndRange = searchObject.find(editor.session);
            let endRow = differenceEndRange ? differenceEndRange.start.row : pathStartLineNumber;
            let endRowText = editor.session.getLine(endRow);
            let endColumn = endRowText.endsWith(",") ? endRowText.length - 1 : endRowText.length;
            textRangeOfPath = new (ace.require("ace/range").Range)(
                pathStartLineNumber,
                highlightStartColumn,
                endRow,
                endColumn
            );
        } else {
            let endRow = editor.session.getLine(pathStartLineNumber);
            let endColumn = endRow.endsWith(",") ? endRow.length - 1 : endRow.length;
            textRangeOfPath = new (ace.require("ace/range").Range)(
                pathStartLineNumber,
                highlightStartColumn,
                pathStartLineNumber,
                endColumn
            );
        }
        return textRangeOfPath;
    }

    _getLastKeyFromPath(path) {
        if (_.isEmpty(path)) {
            return;
        }
        let currentPathKey = _.last(path);
        currentPathKey = currentPathKey.startsWith("_idx_")
            ? currentPathKey.substring("_idx_".length)
            : currentPathKey;
        return currentPathKey;
    }

    _getParentPath(path) {
        if (_.isEmpty(path)) {
            return;
        }
        return _.slice(path, 0, path.length - 1);
    }

    _removeHighlightMarkers() {
        let leftMarkers = this._leftEditor.session.getMarkers(false);
        this._deleteGivenMarkers(leftMarkers, this._leftEditor);
        let rightMarkers = this._rightEditor.session.getMarkers(false);
        this._deleteGivenMarkers(rightMarkers, this._rightEditor);
        this._markers = [];
    }

    _deleteGivenMarkers(markers, editor) {
        Object.keys(markers).forEach(function (markerId) {
            editor.session.removeMarker(markerId);
        });
    }

    // _clearGutterDecorations(editor, sideBySideView = true) {
    //     if(sideBySideView) {
    //         return;
    //     }
    //     let markersCount = this._markers.length;
    //     let editorSession = editor.session;
    //     for(let i=0; i< markersCount; i++) {
    //         let leftMarkerStartRow = _.get(this._markers[i], 'left.range.start.row', undefined);
    //
    //         if(leftMarkerStartRow && editorSession.$decorations[leftMarkerStartRow] !== "") {
    //             editorSession.removeGutterDecoration(leftMarkerStartRow, 'left-diff');
    //         }
    //         let rightMarkerStartRow = _.get(this._markers[i], 'right.range.start.row', undefined);
    //         if(rightMarkerStartRow && editorSession.$decorations[rightMarkerStartRow] !== "") {
    //             editorSession.removeGutterDecoration(rightMarkerStartRow, 'right-diff');
    //         }
    //     }
    // }

    _switchToSinglePaneView() {
        if (!this._rootElement.classList.contains("single-pane-view")) {
            let sideBySideMarkers = this._markers;
            this._removeHighlightMarkers();
            this._rootElement.classList.add("single-pane-view");
            this._toggleViewButton.innerHTML = IconRegistry.getRegisteredIcon(
                "configdrift.compare_side_by_side"
            ).icon;
            this._toggleViewButton.title = "Switch to Side By Side View";
            this._leftEditor.session.setUseWorker(false);
            let singlePaneMarkers = this._addMarkersInSinglePaneView(sideBySideMarkers);
            this._setMarkers(singlePaneMarkers);
            this._setSynchronizedScroll();
            this._jsonDiffNavigationComponent.setSideBySideView(false);
            // this._rerenderLeftGutter(false);
        }
    }

    _addMarkersInSinglePaneView(sideBySideMarkers) {
        let linesAdded = 0;
        let singlePaneMarkers = [];
        let previousSinglePaneMarkerRange = undefined;
        for (let i = 0; i < sideBySideMarkers.length; i++) {
            let currentMakers = sideBySideMarkers[i];
            let leftMarker = currentMakers.left;
            let rightMarker = currentMakers.right;
            let previousMarkers = i === 0 ? undefined : sideBySideMarkers[i - 1];
            if (leftMarker.clazz === "added-line") {
                let updateLeftEmptyParent = this._leftJsonParentEmptyAndNeedsUpdate(
                    leftMarker,
                    rightMarker,
                    previousMarkers,
                    linesAdded
                );
                let newMarker = this._createTextAddedMarkerOnSinglePaneView(
                    leftMarker,
                    rightMarker,
                    linesAdded,
                    previousMarkers,
                    previousSinglePaneMarkerRange,
                    updateLeftEmptyParent
                );
                previousSinglePaneMarkerRange = newMarker.range;
                singlePaneMarkers.push({left: undefined, right: newMarker});
                linesAdded = updateLeftEmptyParent ? linesAdded + 1 : linesAdded;
            } else if (leftMarker.clazz === "removed") {
                let newMarker = this._createTextRemovedMarkerOnSinglePaneView(
                    leftMarker,
                    linesAdded
                );
                singlePaneMarkers.push({left: newMarker, right: undefined});
            } else if (leftMarker.clazz === "updated-background") {
                let newMarkerLeft = this._createTextRemovedMarkerOnSinglePaneView(
                    leftMarker,
                    linesAdded
                );
                let newMarkerRight = this._createTextAddedMarkerOnSinglePaneView(
                    leftMarker,
                    rightMarker,
                    linesAdded,
                    undefined,
                    undefined
                );
                singlePaneMarkers.push({left: newMarkerLeft, right: newMarkerRight});
                this._highlightUpdateDifferencesInSinglePaneView(
                    newMarkerLeft.range,
                    newMarkerRight.range
                );
            }
            linesAdded +=
                leftMarker.clazz === "removed"
                    ? 0
                    : rightMarker.range.end.row -
                      rightMarker.range.start.row +
                      (rightMarker.range.end.column === 0 ? 0 : 1);
            previousSinglePaneMarkerRange =
                leftMarker.clazz !== "added-line" ? undefined : previousSinglePaneMarkerRange;
        }
        return singlePaneMarkers;
    }

    _highlightUpdateDifferencesInSinglePaneView(leftHighlightRange, rightHighlightRange) {
        let leftMarkerText = this._leftEditor.session.getTextRange(leftHighlightRange);
        let rightMarkerText = this._leftEditor.session.getTextRange(rightHighlightRange);
        let leftValueStartColumn = this._getValueStartIndexFromText(leftMarkerText);
        let rightValueStartColumn = this._getValueStartIndexFromText(rightMarkerText);
        let leftValueEndColumn = leftMarkerText.endsWith(",")
            ? leftHighlightRange.end.column - 1
            : leftHighlightRange.end.column;
        let rightValueEndColumn = rightMarkerText.endsWith(",")
            ? rightHighlightRange.end.column - 1
            : rightHighlightRange.end.column;
        let leftMarkerRange = new (ace.require("ace/range").Range)(
            leftHighlightRange.start.row,
            leftValueStartColumn,
            leftHighlightRange.end.row,
            leftValueEndColumn
        );
        let rightMarkerRange = new (ace.require("ace/range").Range)(
            rightHighlightRange.start.row,
            rightValueStartColumn,
            rightHighlightRange.end.row,
            rightValueEndColumn
        );
        let newVal = this._parseValueFromString(leftMarkerText, leftMarkerRange);
        let oldVal = this._parseValueFromString(rightMarkerText, rightMarkerRange);

        this._highlightUpdateDifferences(
            {oldVal: newVal, newVal: oldVal},
            leftMarkerRange,
            rightMarkerRange,
            false
        );
    }

    _getValueStartIndexFromText(valueStr) {
        let keyMatchRegex = /^(\s)*".*": /;
        let keyMatch = keyMatchRegex.exec(valueStr);
        let valueStartIndex = keyMatch ? keyMatch[0].length : valueStr.search(/\S/);
        return valueStartIndex;
    }

    _parseValueFromString(markerText, valueRange) {
        let valueStr = markerText.substring(valueRange.start.column);
        valueStr = valueStr.endsWith(",") ? valueStr.slice(0, -1) : valueStr;
        valueStr = valueStr.startsWith('"') ? valueStr.slice(1, -1) : valueStr;
        let valueParsed = valueStr;
        if (!isNaN(valueStr)) {
            valueParsed = parseFloat(valueStr);
        } else if (_.isBoolean(valueStr)) {
            valueParsed = valueStr === "true";
        } else if (valueRange.isMultiLine()) {
            try {
                valueParsed = JSON.parse(valueStr);
            } catch (ex) {
                // console.log()
            }
        }
        return valueParsed;
    }

    _createTextAddedMarkerOnSinglePaneView(
        leftMarker,
        rightMarker,
        linesAdded,
        previousMarker,
        previousSinglePaneMarkerRange,
        updateLeftEmptyParent = false
    ) {
        let textRangeEndRow =
            rightMarker.range.end.column === 0
                ? rightMarker.range.end.row
                : rightMarker.range.end.row + 1;
        let leftMarkerStartLine = this._leftEditor.session.getLine(
            leftMarker.range.start.row + linesAdded
        );
        let insertColumn = 0;
        if (updateLeftEmptyParent) {
            let indexOfEmptyObject = leftMarkerStartLine.indexOf("{}");
            indexOfEmptyObject =
                indexOfEmptyObject === -1 ? leftMarkerStartLine.indexOf("[]") : indexOfEmptyObject;
            insertColumn = indexOfEmptyObject + 1;
        }
        let textRange = new (ace.require("ace/range").Range)(
            rightMarker.range.start.row,
            0,
            textRangeEndRow,
            0
        );
        let textToAdd = this._rightEditor.session.getTextRange(textRange);

        let addedMarkerStartRow = linesAdded + leftMarker.range.start.row;
        if (leftMarker.clazz === "updated-background") {
            addedMarkerStartRow = linesAdded + leftMarker.range.end.row + 1;
        } else if (
            _.has(previousMarker, "left") &&
            previousMarker.left.range.isEqual(leftMarker.range)
        ) {
            addedMarkerStartRow = previousSinglePaneMarkerRange.end.row + 1;
        }
        let addedMarkerEndRow =
            addedMarkerStartRow + (rightMarker.range.end.row - rightMarker.range.start.row);
        if (rightMarker.range.end.column === 0) {
            addedMarkerEndRow = addedMarkerEndRow - 1;
        }
        if (updateLeftEmptyParent) {
            let indentationOfParent = leftMarkerStartLine.search(/\S/);
            textToAdd = "\n" + textToAdd + " ".repeat(indentationOfParent);
        }
        let markerEndColumn = this._rightEditor.session.getLine(rightMarker.range.end.row).length;

        this._leftEditor.session.insert(
            {row: addedMarkerStartRow, column: insertColumn},
            textToAdd
        );
        if (updateLeftEmptyParent) {
            addedMarkerStartRow++;
            addedMarkerEndRow++;
        }
        let addedMarkerRange = new (ace.require("ace/range").Range)(
            addedMarkerStartRow,
            0,
            addedMarkerEndRow,
            markerEndColumn
        );
        let newMarkerId = this._leftEditor.session.addMarker(
            addedMarkerRange,
            "added",
            "fullLine",
            false
        );
        let newMarker = this._leftEditor.session.getMarkers(false)[newMarkerId];
        return newMarker;
    }

    _leftJsonParentEmptyAndNeedsUpdate(leftMarker, rightMarker, previousMarker, linesAdded) {
        let leftMarkerStartLine = this._leftEditor.session.getLine(
            leftMarker.range.start.row + linesAdded
        );
        let rightMarkerStartLine = this._rightEditor.session.getLine(rightMarker.range.start.row);
        let currentLeftDifferenceHasEmptyObject =
            leftMarkerStartLine.indexOf("{}") > -1 || leftMarkerStartLine.indexOf("[]");
        let leftJsonParentEmpty =
            leftMarker.clazz === "added-line" &&
            currentLeftDifferenceHasEmptyObject &&
            leftMarkerStartLine.search(/\S/) < rightMarkerStartLine.search(/\S/);
        leftJsonParentEmpty = leftJsonParentEmpty
            ? !(
                  _.has(previousMarker, "left") &&
                  previousMarker.left.range.isEqual(leftMarker.range)
              )
            : leftJsonParentEmpty;
        return leftJsonParentEmpty;
    }

    _createTextRemovedMarkerOnSinglePaneView(leftMarker, linesAdded) {
        let newMarkerStartRow = linesAdded + leftMarker.range.start.row;
        let newMarkerEndRow = linesAdded + leftMarker.range.end.row - 1;
        if (leftMarker.range.end.column !== 0) {
            newMarkerEndRow = newMarkerEndRow + 1;
        }
        let newMarkerEndColumn = this._leftEditor.session.getLine(newMarkerEndRow).length;
        let newMarkerRange = new (ace.require("ace/range").Range)(
            newMarkerStartRow,
            0,
            newMarkerEndRow,
            newMarkerEndColumn
        );
        let newMarkerId = this._leftEditor.session.addMarker(
            newMarkerRange,
            "removed",
            "fullLine",
            false
        );

        let newMarker = this._leftEditor.session.getMarkers(false)[newMarkerId];
        return newMarker;
    }

    _switchToSideBySideView() {
        if (this._rootElement.classList.contains("single-pane-view")) {
            // this._clearGutterDecorations(this._leftEditor, false);
            // this._rerenderLeftGutter(true);
            this._setFirstJsonOnEditor();
            this._rootElement.classList.remove("single-pane-view");
            this._toggleViewButton.innerHTML = IconRegistry.getRegisteredIcon(
                "configdrift.compare_line_by_line"
            ).icon;
            this._toggleViewButton.title = "Switch to Single Pane View";
            this._leftEditor.session.setUseWorker(true);
            this._jsonDiffNavigationComponent.setScrollSynchronized(this._model.scrollSynchronized);
            this._jsonDiffNavigationComponent.setSideBySideView(true);
            return;
        }
    }

    // _rerenderLeftGutter(sideBySideView = true) {
    //     this._leftEditor.session.gutterRenderer = {
    //         sideBySideView : sideBySideView,
    //         getWidth: function (session, lastLineNumber, config) {
    //             let maxGutterChars = (lastLineNumber + '').length;
    //             if (!this.sideBySideView) {
    //                 maxGutterChars +=3;
    //             }
    //             return maxGutterChars * config.characterWidth + 5;
    //         },
    //         getText: function(session, row) {
    //             return row+1;
    //         }
    //     };
    //     this._leftEditor.renderer.setShowGutter(false);
    //     this._leftEditor.renderer.setShowGutter(true);
    // }
    /*******************************************/
    /* END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = JsonDiffControlRenderer;
